var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('isHeader',{ref:"isHeader"}),_c('div',{ref:"scrollBox",staticStyle:{"height":"100vh","overflow-y":"auto","overflow-x":"hidden"}},[_c('commonTop',{attrs:{"info":{
        title: '公司使命',
        // desc: '疾病管理与健康体检一体化开拓者',
        smallDesc: '以科技的力量让生命更健康',
        show_desc: true,
      },"img":require('@/assets/aboutUs/banner.png')}},[_c('div',[_c('h1',{staticClass:"title title2"},[_vm._v("公司愿景")]),_c('div',[_vm._v("智慧慢病服务普惠千家医院、守护亿万患者。我们是以AI为引擎、以专病为纵深、以服务为核心的慢病管理运营商。")])])]),_c('isCom'),_c('isFooter')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }